// extracted by mini-css-extract-plugin
export default {"f":"_1819bd50ef","main":"_4dcd1fe78f","btn":"a772935d41","w":"dc0ce2133c","h":"b9bbd39a8a","lh25":"_68311e6123","wb":"_545a5cab27","b":"_21f12bedd2","bx":"f650236b16"};